// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleAudioPlayer__container-c9f821 {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  width: 100vw;
  max-width: 100%;
}

.ArticleAudioPlayer__icon-ea5528 {
  cursor: pointer;
  margin-inline-end: 8px;
}

.ArticleAudioPlayer__title-d7cf62 {
  color: var(--base-110);
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/AudioPlayer/ArticleAudioPlayer/ArticleAudioPlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  width: 100vw;\n  max-width: 100%;\n}\n\n.icon {\n  cursor: pointer;\n  margin-inline-end: 8px;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticleAudioPlayer__container-c9f821`,
	"icon": `ArticleAudioPlayer__icon-ea5528`,
	"title": `ArticleAudioPlayer__title-d7cf62`
};
module.exports = ___CSS_LOADER_EXPORT___;
